import React, { Component } from 'react'
import styled from 'styled-components'

const StyledDiv = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
`

class Report extends Component {
  componentDidMount() {
    if (this.iframeRef.current) {
      this.iframeRef.current.contentWindow.location.replace(this.props.url)
    }
    if (this.props.tracker) {
      //this.props.tracker()
    }
  }

  iframeRef = React.createRef()

  render() {
    return (
      <StyledDiv>
        <iframe
          src=""
          referrerPolicy="no-referrer"
          ref={this.iframeRef}
          style={{ height: '100%', width: '100%', border: 'none' }}
        />
      </StyledDiv>
    )
  }
}

export default Report
